/*
  Tohfa by Sonia — collection sort.

  Submits the sort form on change so the select behaves like the prototype's.
  Without JS the form still works: a submit button is exposed inside <noscript>.
  Sorting itself is Shopify's, via the sort_by query parameter — no client-side
  filtering, no reordering in the browser.
*/
(function () {
  var form = document.getElementById('tohfa-sort');
  if (!form) return;

  var select = form.querySelector('select[name="sort_by"]');
  if (!select) return;

  select.addEventListener('change', function () {
    form.submit();
  });
})();
